var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table-sm m-0"},[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('fareGroup.data.free_pt_change_duration'))+":")]),_c('td',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.details.free_pt_change_duration))])])])}
var staticRenderFns = []

export { render, staticRenderFns }